export default __webpack_public_path__ + "static/media/vuesax-linear-clock.6b027c4c.svg";